import PropTypes from 'prop-types';
import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import Box from 'retired/Box';

import Step from './Step';
import StepContent from './StepContent';
import StepLabel from './StepLabel';
import Stepper from './Stepper';

export { Step, StepContent, StepLabel, Stepper };

const DisabledButton = withStyles(() => ({
  root: {
    color: '#00000042',
    backgroundColor: '#0000001f',
    border: '1px solid #0000001f',
    '&:hover': {
      color: '#00000042',
      backgroundColor: '#0000001f',
      border: '1px solid #0000001f',
    },
  },
}))(Button);

const ContentContainer = withStyles(() => ({
  root: {
    marginTop: 25,
    marginBottom: 30,
    marginLeft: 28,
  },
}))(Box);

/* eslint-disable jsx-a11y/label-has-for */
const FieldLabel = ({ children, forName }) => (
  <span style={{ fontSize: 20, textTransform: 'capitalize', fontWeight: 'bold' }} htmlFor={forName}>
    {children}
  </span>
);
FieldLabel.propTypes = {
  children: PropTypes.node,
  forName: PropTypes.string,
};
/* eslint-disable jsx-a11y/label-has-for */

const StepperComponent = (props) => {
  const {
    labelText,
    children,
    componentIndex,
    currentStep,
    finalStep,
    icon,
    nextDisabled,
    handleNext,
    id = 'stepper-content',
  } = props;

  const NextButton = nextDisabled ? DisabledButton : Button;

  return (
    <Step
      active
      // TODO: Remove completed prop
      completed={false}
    >
      <StepLabel icon={icon || componentIndex + 1}>
        <FieldLabel>{labelText}</FieldLabel>
      </StepLabel>
      <StepContent>
        <ContentContainer id={id}>
          {children}
          {componentIndex === currentStep &&
            !finalStep && ( // if we are on this step, show the 'Next' button
              <div style={{ paddingTop: 24, paddingBottom: 4 }}>
                <NextButton
                  disableRipple
                  disableFocusRipple
                  color="primary"
                  variant="contained"
                  onClick={handleNext}
                >
                  Next
                </NextButton>
              </div>
            )}
        </ContentContainer>
      </StepContent>
    </Step>
  );
};

StepperComponent.propTypes = {
  labelText: PropTypes.string.isRequired, // label for this step
  children: PropTypes.node.isRequired, // elements for this step
  componentIndex: PropTypes.number.isRequired, // which step number is this step
  currentStep: PropTypes.number, // which step number is the stepper on
  handleNext: PropTypes.func, // callback to execute when 'Next' button is touched
  nextDisabled: PropTypes.bool, // is step valid?
  finalStep: PropTypes.bool, // is this the final step (do not show 'Next' if so)
  icon: PropTypes.object, // custom icon for this step
  id: PropTypes.string, // id for the content container
};

export default StepperComponent;
